import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addCustomerAddress } from "../../../redux/reduxSlice/website/CustomerAddAddressSlice";
import { toast } from "react-toastify";

import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import Button from "../../../ui/Button";
import { Country, State, City } from "country-state-city";
import {
  convertcartToSalesOrder,
  getContactByEmail,
  deleteAddress,
  updateAddress,
  createRazorpayPaymentLink,
  checkPaymentStatus
} from "../../../redux/api/website/CheckoutApi";
import { getCustomerAddressNew } from "../../../redux/reduxApi/website/CustomerAddressApi";
import { getCartProductsWebuser } from "../../../redux/reduxApi/website/CartProductCount";
import Shoploader from "../loader/Shoploader";
import { FaArrowLeft } from "react-icons/fa";
import { Check, MoveLeft, SquarePen, Trash2, X } from "lucide-react";
import OrderSummary from "./OrderSummary";


const CheckoutPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // Step management: 1 for address, 2 for payment, 3 for success
  const [step, setStep] = useState(1);

  // Addresses state
  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null); // Add state for full address object
  const [showNewAddressForm, setShowNewAddressForm] = useState(false);
  const [paymentOrderId, setPaymentOrderId] = useState(null);
  const [pollingInterval, setPollingInterval] = useState(null);

  // Edit address state
  const [editingAddress, setEditingAddress] = useState(null);
  const [showEditForm, setShowEditForm] = useState(false);

  // New address form state
  const [newAddress, setNewAddress] = useState({
    country: { name: "India", id: "IN" },
    name: "",
    company: "",
    address: "",
    apartment: "",
    city: "",
    state: "",
    postalCode: "",
    phone: "",
  });

  // Country, state, city options for selects
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);

  // Cart items from redux
  const cartState = useSelector((state) => state.Cart.CartProducts);
  console.log("cartStatessss", cartState)
  const cartItems =
    cartState && cartState.cart && Array.isArray(cartState.cart.products)
      ? cartState.cart.products
      : [];

  // Get userId from localStorage directly
  const userId = localStorage.getItem("UserRowId");

  // Bulky item detection and separation
  const [hasBulkyItem, setHasBulkyItem] = useState(false);
  const [bulkyItems, setBulkyItems] = useState([]);
  const [nonBulkyItems, setNonBulkyItems] = useState([]);

  // Popup visibility
  const [showBulkyPopup, setShowBulkyPopup] = useState(false);
  const [bulkyOrderPlaced, setBulkyOrderPlaced] = useState(false);

  // Payment option selected
  const [paymentOption, setPaymentOption] = useState("");

  // Loading states
  const [isLoading, setIsLoading] = useState(false);

  // Add states for cart calculations
  const [subtotal, setSubtotal] = useState(0);
  const [shippingCost, setShippingCost] = useState(0);
  const [total, setTotal] = useState(0);
  const [cartProducts, setCartProducts] = useState([]);

  // Function to start polling payment status
  const startPollingPaymentStatus = (orderId) => {
    toast.info("Verifying payment status...");

    const interval = setInterval(async () => {
      try {
        const status = await checkPaymentStatus(orderId);

        if (status.success) {
          if (status.status === "Paid" || status.orderStatus === "Confirmed") {

            clearInterval(interval);

            const orderId = sessionStorage.getItem("currentOrderId");
            const amount = sessionStorage.getItem("orderAmount");
            const address = JSON.parse(
              sessionStorage.getItem("selectedAddress")
            );

            navigate("/orderconfirm", {
              state: {
                orderId,
                amount,
                selectedAddress: address,
              },
            });

            sessionStorage.removeItem("currentOrderId");
            sessionStorage.removeItem("orderAmount");
            sessionStorage.removeItem("selectedAddress");
          } else if (status.status === "Failed") {
            // Payment failed
            clearInterval(interval);
            setPollingInterval(null);
            toast.error("Payment failed. Please try again.");
            // Handle failure (maybe go back to checkout)
          }
        }
      } catch (error) {
        console.error("Error checking payment status:", error);
      }
    }, 3000); // Poll every 3 seconds

    setPollingInterval(interval);

    // Stop polling after 2 minutes (timeout)
    setTimeout(() => {
      if (interval) {
        clearInterval(interval);
        setPollingInterval(null);
        toast.warning("Payment verification is taking longer than expected. We'll notify you once confirmed.");
        // Still show success page - webhook will update later
        // setStep(3);
        setPaymentOrderId(orderId);
      }
    }, 120000);
  };

  // Fetch addresses function
  const fetchAddresses = async () => {
    if (!userId) {
      setShowNewAddressForm(true);
      return;
    }

    setIsLoading(true);
    try {
      const res = await dispatch(getCustomerAddressNew()).unwrap();
      console.log("Fetch addresses response:", res);

      if (res?.data && Array.isArray(res.data)) {
        setAddresses(res.data);

        if (res.data.length > 0) {
          // Try to find default address first
          const defaultAddr = res.data.find((addr) => addr.defaultAddress);
          if (defaultAddr) {
            setSelectedAddressId(defaultAddr.ROWID);
            setSelectedAddress(defaultAddr); // Set full address object
          } else {
            setSelectedAddressId(res.data[0].ROWID);
            setSelectedAddress(res.data[0]); // Set full address object
          }
          setShowNewAddressForm(false);
        } else {
          setShowNewAddressForm(true);
        }
      }
    } catch (err) {
      console.error("Error fetching addresses:", err);
      toast.error("Failed to fetch addresses");
      setShowNewAddressForm(true);
    } finally {
      setIsLoading(false);
    }
  };

  // Add function to fetch cart and calculate totals
  const fetchCartAndCalculateTotals = async () => {
    try {
      const cartResponse = await dispatch(getCartProductsWebuser()).unwrap();

      if (cartResponse?.data) {
        const products = cartResponse.data;
        console.log("Cart products fetched:", products);
        setCartProducts(products);

        // Calculate subtotal
        const subtotalValue = products.reduce((acc, product) => {
          const price = parseFloat(product.total);
          // const quantity = parseInt(product.quantity) || 1;
          return acc + price
        }, 0);

        console.log("c", subtotalValue);

        setSubtotal(subtotalValue);

        // Calculate shipping (using same 0.18 rate as in OrderSummary)
        // const shippingRate = 0.18;
        // const shippingValue = subtotalValue * shippingRate;
        // setShippingCost(shippingValue);

        // console.log("calculate shipping rate", shippingValue)
        // Calculate total
        // setTotal(subtotalValue + shippingCost);
        // console.log("total value", total);
      }
    } catch (error) {
      console.error("Error fetching cart:", error);
    }
  };

  useEffect(() => {
    setTotal(parseFloat(subtotal || 0) + parseFloat(shippingCost || 0));
  }, [subtotal, shippingCost]);

  // Initial fetch on component mount
  useEffect(() => {
    fetchAddresses();
    if (userId) {
      fetchCartAndCalculateTotals();
    }

    // Cleanup polling on unmount
    return () => {
      if (pollingInterval) {
        clearInterval(pollingInterval);
      }
    };
  }, [dispatch, userId]);

  // Handle payment return and start polling
  useEffect(() => {
    // Check if we're returning from Razorpay
    const urlParams = new URLSearchParams(window.location.search);
    const razorpayPaymentId = urlParams.get('razorpay_payment_id');
    const razorpayOrderId = urlParams.get('razorpay_order_id');

    const currentOrderId = sessionStorage.getItem('currentOrderId');

    if ((razorpayPaymentId || razorpayOrderId) && currentOrderId) {
      // Clear the URL parameters without refreshing
      window.history.replaceState({}, document.title, window.location.pathname);

      // Start polling for payment status
      startPollingPaymentStatus(currentOrderId);
    }

    // Check if we're returning from payment with stored success flag
    const paymentSuccess = localStorage.getItem('paymentSuccess');
    const orderId = localStorage.getItem('paymentOrderId');

    if (paymentSuccess === 'true' && orderId) {
      // Clear stored flags
      localStorage.removeItem('paymentSuccess');
      localStorage.removeItem('paymentOrderId');

      // Set the order ID for display
      setPaymentOrderId(orderId);

      // Move to success step
      // setStep(3);
      toast.success("Payment completed successfully!");
    }

    // Check if we have state from navigation
    if (location.state?.step === 3) {
      // setStep(3);
      if (location.state?.orderId) {
        setPaymentOrderId(location.state.orderId);
      }
    }
  }, [location]);

  // Handle selecting an address
  const handleSelectAddress = (id) => {
    console.log("Selected address ID:", id);
    setSelectedAddressId(id);

    // Find and set the full address object
    const address = addresses.find(addr => addr.ROWID === id);
    if (address) {
      setSelectedAddress(address);
    }

    setShowNewAddressForm(false);
    setShowEditForm(false);
  };

  // Handle delete address
  const handleDeleteAddress = async (addressId, e) => {
    e.stopPropagation();
    setIsLoading(true);
    try {
      const response = await dispatch(deleteAddress(addressId)).unwrap();
      if (response?.message === "Delivery Address deleted successfully") {
        toast.success("Address deleted successfully");
        const updatedRes = await dispatch(getCustomerAddressNew()).unwrap();
        if (updatedRes?.data) {
          setAddresses(updatedRes.data);
          if (selectedAddressId === addressId) {
            if (updatedRes.data.length > 0) {
              const defaultAddr = updatedRes.data.find((a) => a.defaultAddress);
              const newSelectedId = defaultAddr ? defaultAddr.ROWID : updatedRes.data[0].ROWID;
              setSelectedAddressId(newSelectedId);

              // Update selected address object
              const newAddress = updatedRes.data.find(addr => addr.ROWID === newSelectedId);
              setSelectedAddress(newAddress || null);
            } else {
              setSelectedAddressId(null);
              setSelectedAddress(null);
              setShowNewAddressForm(true);
            }
          }
        }
      }
    } catch (error) {
      console.error("Error deleting address:", error);
      toast.error(error?.message || "Failed to delete address");
    } finally {
      setIsLoading(false);
    }
  };

  // Handle edit address
  const handleEditAddress = (address, e) => {
    e.stopPropagation();

    console.log("Editing address:", address);

    // Find country from Country.getAllCountries()
    const countryObj = Country.getAllCountries().find(
      (c) => c.name === address.country
    );

    let stateObj = null;
    if (countryObj) {
      stateObj = State.getStatesOfCountry(countryObj.isoCode).find(
        (s) => s.name === address.state
      );
    }

    setEditingAddress(address);

    setNewAddress({
      country: countryObj
        ? { name: countryObj.name, id: countryObj.isoCode }
        : { name: address.country || "India", id: "IN" },
      name: address.name || "",
      company: address.company || "",
      address: address.address || "",
      apartment: address.apartment || "",
      city: { name: address.city || "" },
      state: stateObj
        ? { name: stateObj.name, id: stateObj.isoCode }
        : { name: address.state || "", id: "" },
      postalCode: address.postalCode || "",
      phone: address.phone || "",
    });

    // Set state options based on country
    if (countryObj) {
      const states = State.getStatesOfCountry(countryObj.isoCode).map((s) => ({
        label: s.name,
        value: s.isoCode,
      }));
      setStateOptions(states);
    }

    // Set city options if state exists
    if (countryObj && stateObj) {
      const cities = City.getCitiesOfState(countryObj.isoCode, stateObj.isoCode).map((c) => ({
        label: c.name,
        value: c.name,
      }));
      setCityOptions(cities);
    }

    setShowEditForm(true);
    setShowNewAddressForm(false);
  };

  // Handle input change in new address form
  const handleNewAddressChange = (e) => {
    const { id, value } = e.target;
    setNewAddress((prev) => ({ ...prev, [id]: value }));
  };

  // Handle country change
  const handleCountryChange = (selectedOption) => {
    console.log("selectedOption currency", selectedOption);
    if (!selectedOption) return;
    const country = { name: selectedOption.label, id: selectedOption.value };
    setNewAddress((prev) => ({ ...prev, country, state: "", city: "" }));
    const states = State.getStatesOfCountry(selectedOption.value).map((s) => ({
      label: s.name,
      value: s.isoCode,
    }));
    setStateOptions(states);
    setCityOptions([]);
  };

  useEffect(() => {
    const states = State.getStatesOfCountry("IN").map((s) => ({
      label: s.name,
      value: s.isoCode,
    }));
    setStateOptions(states);
  }, []);

  // Handle state change
  const handleStateChange = (selectedOption) => {
    if (!selectedOption) return;
    const state = { name: selectedOption.label, id: selectedOption.value };
    setNewAddress((prev) => ({ ...prev, state, city: "" }));
    const cities = City.getCitiesOfState(
      newAddress.country.id,
      selectedOption.value,
    ).map((c) => ({ label: c.name, value: c.name }));
    setCityOptions(cities);
  };

  // Handle city change
  const handleCityChange = (selectedOption) => {
    if (!selectedOption) return;
    const city = { name: selectedOption.label };
    setNewAddress((prev) => ({ ...prev, city }));
  };

  // Handle add new address
  const handleAddAddress = async () => {
    if (
      !newAddress.name ||
      !newAddress.address ||
      !newAddress.apartment ||
      !newAddress.city?.name ||
      !newAddress.state?.name ||
      !newAddress.country?.name ||
      !newAddress.postalCode ||
      !newAddress.phone
    ) {
      toast.error("Please fill all required fields in the address form.");
      return;
    }

    setIsLoading(true);
    try {
      const userEmail = localStorage.getItem("userEmail");

      // Fetch contact using email
      const contactResponse = await getContactByEmail(userEmail);

      if (!contactResponse?.success || !contactResponse?.rowid?.[0]?.contact) {
        toast.error("Contact not found for this user789.");
        return;
      }

      const contactRowId = contactResponse?.rowid?.[0]?.contact.ROWID;

      const payload = {
        country: newAddress.country.name,
        name: newAddress.name,
        company: newAddress.company || "",
        address: newAddress.address,
        apartment: newAddress.apartment || "",
        city: newAddress.city.name,
        state: newAddress.state.name,
        postalCode: newAddress.postalCode,
        phone: newAddress.phone,
        contactId: contactRowId,
        webuserId: userId,
      };

      console.log("Add address payload:", payload);

      const res = await dispatch(addCustomerAddress(payload)).unwrap();
      console.log("Add address response:", res);

      if (res?.message === "Delivery Address created successfully") {
        toast.success("Address added successfully");

        // Fetch updated addresses
        const updatedRes = await dispatch(getCustomerAddressNew()).unwrap();
        if (updatedRes?.data) {
          setAddresses(updatedRes.data);

          if (updatedRes.data.length > 0) {
            const defaultAddr = updatedRes.data.find((a) => a.defaultAddress);
            const newSelectedId = defaultAddr ? defaultAddr.ROWID : updatedRes.data[0].ROWID;
            setSelectedAddressId(newSelectedId);

            // Update selected address object
            const newAddressObj = updatedRes.data.find(addr => addr.ROWID === newSelectedId);
            setSelectedAddress(newAddressObj || null);
          }
        }

        // Reset form
        setNewAddress({
          country: { name: "India", id: "IN" },
          name: "",
          company: "",
          address: "",
          apartment: "",
          city: "",
          state: "",
          postalCode: "",
          phone: "",
        });

        setShowNewAddressForm(false);
        setShowEditForm(false);
        setEditingAddress(null);
      }
    } catch (error) {
      console.error("Error adding address:", error);
      toast.error(error?.message || "Failed to add address");
    } finally {
      setIsLoading(false);
    }
  };

  // Handle update address
  const handleUpdateAddress = async () => {
    if (
      !newAddress.name ||
      !newAddress.address ||
      !newAddress.city?.name ||
      !newAddress.state?.name ||
      !newAddress.country?.name ||
      !newAddress.postalCode ||
      !newAddress.phone
    ) {
      toast.error("Please fill all required fields in the address form.");
      return;
    }

    setIsLoading(true);
    try {
      const userEmail = localStorage.getItem("userEmail");
      const contactResponse = await getContactByEmail(userEmail);

      if (!contactResponse?.success || !contactResponse?.rowid?.[0]?.contact) {
        toast.error("Contact not found for this user456.");
        return;
      }

      const contactRowId = contactResponse?.rowid?.[0]?.contact.ROWID;
      const addressId = editingAddress.ROWID;
      const payload = {
        country: newAddress.country.name,
        name: newAddress.name,
        company: newAddress.company || "",
        address: newAddress.address,
        apartment: newAddress.apartment || "",
        city: newAddress.city.name,
        state: newAddress.state.name,
        postalCode: newAddress.postalCode,
        phone: newAddress.phone,
        contactId: contactRowId,
        webuserId: userId,
      };
      const res = await dispatch(updateAddress({ addressId, addressData: payload })).unwrap();
      if (res?.message === "Delivery Address updated successfully") {
        toast.success("Address updated successfully");
        const updatedRes = await dispatch(getCustomerAddressNew()).unwrap();
        if (updatedRes?.data) {
          setAddresses(updatedRes.data);
          setSelectedAddressId(addressId);

          // Update selected address object
          const updatedAddress = updatedRes.data.find(addr => addr.ROWID === addressId);
          setSelectedAddress(updatedAddress || null);
        }
        setShowEditForm(false);
        setEditingAddress(null);
        setNewAddress({
          country: { name: "India", id: "IN" },
          name: "",
          company: "",
          address: "",
          apartment: "",
          city: "",
          state: "",
          postalCode: "",
          phone: "",
        });
      }
    } catch (error) {
      console.error("Error updating address:", error);
      toast.error(error?.message || "Failed to update address");
    } finally {
      setIsLoading(false);
    }
  };

  // Handle save and proceed (for both add and edit)
  const handleSaveAndProceed = async () => {
    if (showEditForm) {
      await handleUpdateAddress();
    } else {
      await handleAddAddress();
    }
  };

  // // Handle payment option change
  // const handlePaymentChange = (e) => {
  //   setPaymentOption(e.target.value);
  // };

  

  //   const handleConvertCartToSalesOrder = async () => {
  //     try {
  //       if (!selectedAddressId) {
  //         toast.error("Please select a delivery address first");
  //         return;
  //       }

  //       const userEmail = localStorage.getItem("userEmail");
  //       const contactResponse = await getContactByEmail(userEmail);

  //       if (!contactResponse?.success || !contactResponse?.data?.ROWID) {
  //         toast.error("Contact not found for this user.");
  //         return;
  //       }

  //       const contactId = contactResponse.data.ROWID;

  //       // Ensure totals exist
  //       if (total === 0 || shippingCost === 0) {
  //         await fetchCartAndCalculateTotals();
  //       }

  //       setIsLoading(true);

  //       // 1️⃣ Convert Cart → Sales Order
  //       const res = await convertcartToSalesOrder(
  //         contactId,
  //         selectedAddressId,
  //         shippingCost,
  //         total,
  //         subtotal
  //       );

  //       if (res.status === 200) {
  //         toast.success("Sales Order Created Successfully");

  //         const salesOrderId = res.data.salesOrderId;
  //         const orderTotal = parseFloat(res.data.total);


  //         // console.log("Sales Order:", salesOrderId, "Total:", orderTotal);

  //         // Get user details for payment link
  //         const selectedAddress = addresses.find(addr => addr.ROWID === selectedAddressId);
  //            navigate("/orderconfirm", {
  //   state: {
  //     orderId: salesOrderId,
  //     amount: orderTotal,
  //     selectedAddress : selectedAddress,
  //   }
  // });
  //  console.log("salesOrderId",salesOrderId)

  //         // 2️⃣ Create Razorpay Payment Link (instead of order)
  //         const paymentLinkRes = await createRazorpayPaymentLink({
  //           amount: orderTotal,
  //           rowId: salesOrderId,
  //           customerName: selectedAddress?.name || "Customer",
  //           customerEmail: userEmail,
  //           customerPhone: selectedAddress?.phone || ""
  //         });

  //         if (paymentLinkRes?.success && paymentLinkRes?.payment_url) {
  //           const paymentUrl = paymentLinkRes.payment_url;

  //           console.log("Redirecting to Razorpay Payment Link:", paymentUrl);

  //           // Store order info before redirect
  //           sessionStorage.setItem('currentOrderId', salesOrderId);
  //           sessionStorage.setItem('orderAmount', orderTotal);

  //           // 3️⃣ Redirect to Razorpay Payment Link
  //           window.location.href = paymentUrl;
  //         } else {
  //           toast.error(paymentLinkRes?.message || "Failed to create payment link");
  //           setIsLoading(false);
  //         }
  //       } else {
  //         toast.error(res.message || "Failed to convert cart");
  //         setIsLoading(false);
  //       }
  //     } catch (error) {
  //       console.error("Payment initialization failed:", error);
  //       toast.error(error?.response?.data?.message || "Payment initialization failed");
  //       setIsLoading(false);
  //     }
  //   };
  const handleConvertCartToSalesOrder = async () => {
    try {
      if (!selectedAddressId) {
        toast.error("Please select a delivery address first");
        return;
      }

      const userEmail = localStorage.getItem("userEmail");
      const contactResponse = await getContactByEmail(userEmail);

      if (!contactResponse?.success || !contactResponse?.rowid?.[0]?.contact) {
        toast.error("Contact not found for this user.");
        return;
      }

      const contactId = contactResponse?.rowid?.[0]?.contact.ROWID;

      // Ensure totals exist
      if (total === 0 || shippingCost === 0) {
        await fetchCartAndCalculateTotals();
      }

      setIsLoading(true);

      // 1️⃣ Convert Cart → Sales Order
      const res = await convertcartToSalesOrder(
        contactId,
        selectedAddressId,
        shippingCost,
        total,
        subtotal
      );

      if (res.status === 200) {
        toast.success("Sales Order Created Successfully");

        const salesOrderId = res.data.salesOrderId;
        const orderTotal = parseFloat(res.data.total);

        // Get user details for payment link
        const selectedAddress = addresses.find(addr => addr.ROWID === selectedAddressId);

        // 🧹 Clear the cart first
        const cartItems = cartProducts || cartState?.cart?.products || [];
        const cartRowIds = cartItems.map(item => item.ROWID);
        sessionStorage.setItem("cartRowIds", JSON.stringify(cartRowIds));

        // try {
        //   // Get all cart item ROWIDs to clear
        //   if (cartRowIds.length > 0) {
        //     const clearResult = await dispatch(clearCartApi(cartRowIds)).unwrap();
        //     await dispatch(getCartProductsWebuser());
        //   } else {
        //     console.log("No cart items to clear");
        //   }
        // } catch (clearError) {
        //   console.error("Error clearing cart:", clearError);
        //   // Don't block the payment flow if cart clearing fails
        //   toast.warning("Order created but there was an issue clearing your cart");
        // }

        // navigate("/orderconfirm", {
        //   state: {
        //     orderId: salesOrderId,
        //     amount: orderTotal,
        //     selectedAddress: selectedAddress,
        //   }
        // });

        console.log("salesOrderId", salesOrderId);

        // 2️⃣ Create Razorpay Payment Link
        const paymentLinkRes = await createRazorpayPaymentLink({
          amount: orderTotal,
          rowId: salesOrderId,
          customerName: selectedAddress?.name || "Customer",
          customerEmail: userEmail,
          customerPhone: selectedAddress?.phone || ""
        });

        if (paymentLinkRes?.success && paymentLinkRes?.payment_url) {
          const paymentUrl = paymentLinkRes.payment_url;

          console.log("Redirecting to Razorpay Payment Link:", paymentUrl);

          // Store order info before redirect
          sessionStorage.setItem('currentOrderId', salesOrderId);
          sessionStorage.setItem('orderAmount', orderTotal);

          // Store address in session storage for order confirmation page
          if (selectedAddress) {
            sessionStorage.setItem('selectedAddress', JSON.stringify(selectedAddress));
          }

          // 3️⃣ Redirect to Razorpay Payment Link
          sessionStorage.setItem("orderId", salesOrderId);
          sessionStorage.setItem("orderAmount", orderTotal);
          sessionStorage.setItem(
            "selectedAddress",
            JSON.stringify(selectedAddress)
          );
          window.location.href = paymentUrl;
        } else {
          toast.error(paymentLinkRes?.message || "Failed to create payment link");
          setIsLoading(false);
        }
      } else {
        toast.error(res.message || "Failed to convert cart");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Payment initialization failed:", error);
      toast.error(error?.response?.data?.message || "Payment initialization failed");
      setIsLoading(false);
    }
  };
  return (
    <div className="container mx-auto !px-0 py-6">
      {isLoading && (
        <div className="flex items-center justify-center bg-gradient-to-b from-[#fbfbfb] to-[#f7f7f7] h-full">
          <Shoploader />
        </div>
      )}

      {step === 1 && (
        <>
          {/* Address Grid - 2 Columns */}
          {addresses.length > 0 && !showNewAddressForm && !showEditForm && (
            <div>
              <div className="flex gap-2 justify-between items-center mb-4">
                <div className="flex items-center gap-3">
                  <button
                    onClick={() => navigate(-1)}
                    className="p-1 hover:bg-gray-100 rounded-full transition-colors text-gray-700 cursor-pointer"
                    title="Back"
                  >
                    <FaArrowLeft size="20px" />
                  </button>
                  <div>
                    <h1 className="text-2xl text-[#661e33] font-playfair mb-0">Select Shipping Address</h1>
                    <p className="mb-0">Where should we send your custom blinds?</p>
                  </div>
                </div>
                <button
                  className="mt-2 px-4 py-2 bg-gradient-to-r from-[#66944b] to-[#7fb073] py-2 px-4 text-white rounded h-10 "
                  onClick={() => {
                    setShowNewAddressForm(true);
                    setShowEditForm(false);
                    setEditingAddress(null);
                    // Reset form
                    setNewAddress({
                      country: { name: "India", id: "IN" },
                      name: "",
                      company: "",
                      address: "",
                      apartment: "",
                      city: "",
                      state: "",
                      postalCode: "",
                      phone: "",
                    });
                  }}
                  disabled={isLoading}
                >
                  Add New Address
                </button>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {addresses.map((addr) => (
                  <label
                    key={addr.ROWID}
                    className="group relative cursor-pointer"
                    onClick={() => handleSelectAddress(addr.ROWID)}
                  >
                    <input
                      type="radio"
                      name="shipping_address"
                      value={addr.ROWID}
                      checked={selectedAddressId === addr.ROWID}
                      onChange={() => handleSelectAddress(addr.ROWID)}
                      className="peer sr-only"
                    />

                    <div className={`h-full rounded-2xl border-2 p-6 transition-all peer-checked:border-[#7fb073] peer-checked:bg-[#f0fdf2] dark:border-white/10 dark:bg-surface-dark dark:peer-checked:border-primary dark:peer-checked:bg-primary/5 ${selectedAddressId === addr.ROWID
                      ? 'border-[#7fb073] bg-[#f0fdf2]'
                      : 'border-[#dfe9da]  bg-surface-light'
                      }`}>
                      <div className="space-y-1 text-sm text-gray-600 dark:text-gray-300">
                        <p className="font-medium text-black dark:text-white text-base mb-0">
                          {addr.name || 'Address Name'}
                        </p>
                        <p className="mb-0">{addr.address}</p>
                        {addr.apartment && <p className="text-sm text-gray-600">Apt: {addr.apartment}</p>}
                        <p className="mb-0">{addr.country}</p>
                        <p className="mb-0">{addr.city}, {addr.state}, {addr.postalCode}</p>
                        {addr.company && <p className="text-sm text-gray-600 mb-0">Company: {addr.company}</p>}
                        <p className="text-text-secondary mb-0">Phone: {addr.phone}</p>
                      </div>

                      <div className=" w-full flex justify-end gap-3">
                        <button
                          className="text-xs font-medium  hover:underline flex items-center gap-1 transition-colors text-[#7fb073]"
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditAddress(addr, e);
                          }}
                          disabled={isLoading}
                        >
                          <SquarePen size={20} />
                        </button>
                        <button
                          className="text-xs font-medium text-red-500 hover:text-red-600 hover:underline flex items-center gap-1 transition-colors"
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteAddress(addr.ROWID, e);
                          }}
                          disabled={isLoading}
                        >
                          <Trash2 size={20} />
                        </button>
                      </div>
                    </div>

                    {/* Checkmark overlay for selected address */}
                    <div className={`absolute -right-2 -top-2 ${selectedAddressId === addr.ROWID ? 'flex' : 'hidden'} h-6 w-6 items-center justify-center rounded-full bg-[#7fb073] text-white shadow-sm ring-2 ring-white dark:ring-background-dark`}>
                      <Check size={18} />
                    </div>
                  </label>
                ))}
              </div>
              <div className="w-full flex justify-end items-center mt-2">
                <Button
                  text="Next"
                  onClick={() => {
                    setStep(2);
                  }}
                  disabled={!selectedAddressId}
                />
              </div>
            </div>
          )}
          <div className="flex justify-center">
            {(addresses.length === 0 || showNewAddressForm || showEditForm) && (
              <div className="border-2 border-gray-300  bg-gray-50 drop-shadow-lg shadow rounded-lg mt-4 w-[100%]">
                <h3 className="text-lg font-semibold mb-0 rounded-t-lg px-4 py-3 bg-gradient-to-r from-[#66944b] to-[#7fb073] text-white flex justify-between">
                  {showEditForm ? "Edit Address" : "Add New Address"}
                  <X onClick={() => navigate(-1)} />
                </h3>
                <form className="p-4">
                  {/* Grid layout for 2 columns on large screens */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Name */}
                    <div>
                      <label className="block mb-1">Name<span className="text-red-500">*</span></label>
                      <input
                        id="name"
                        type="text"
                        value={newAddress.name}
                        onChange={handleNewAddressChange}
                        className="w-full p-1.5 border rounded"
                        required
                        disabled={isLoading}
                      />
                    </div>
                    {/* Company */}
                    <div>
                      <label className="block mb-1">Company</label>
                      <input
                        id="company"
                        type="text"
                        value={newAddress.company}
                        onChange={handleNewAddressChange}
                        className="w-full p-1.5 border rounded"
                        disabled={isLoading}
                      />
                    </div>
                    {/* Phone */}
                    <div>
                      <label className="block mb-1">Phone <span className="text-red-500">*</span></label>
                      <input
                        id="phone"
                        type="text"
                        value={newAddress.phone}
                        onChange={handleNewAddressChange}
                        className="w-full p-1.5 border rounded"
                        required
                        disabled={isLoading}
                      />
                    </div>
                    {/* Address */}
                    <div>
                      <label className="block mb-1">Address <span className="text-red-500">*</span></label>
                      <input
                        id="address"
                        type="text"
                        value={newAddress.address}
                        onChange={handleNewAddressChange}
                        className="w-full p-1.5 border rounded"
                        required
                        disabled={isLoading}
                      />
                    </div>
                    {/* Apartment */}
                    <div>
                      <label className="block mb-1">Apartment <span className="text-red-500">*</span></label>
                      <input
                        id="apartment"
                        type="text"
                        value={newAddress.apartment}
                        onChange={handleNewAddressChange}
                        className="w-full p-1.5 border rounded"
                        disabled={isLoading}
                      />
                    </div>
                    {/* Country */}
                    <div>
                      <label className="block mb-1">Country <span className="text-red-500">*</span></label>
                      <Select
                        options={Country.getAllCountries().map((c) => ({
                          label: c.name,
                          value: c.isoCode,
                        }))}
                        value={{
                          label: newAddress.country.name || "Indian",
                          value: newAddress.country.id || "IN",
                        }}
                        onChange={handleCountryChange}
                        className="mb-2"
                        isDisabled={isLoading}
                      />
                    </div>
                    {/* State */}
                    <div>
                      <label className="block mb-1">State <span className="text-red-500">*</span></label>
                      <Select
                        options={stateOptions}
                        value={
                          newAddress.state.name
                            ? {
                              label: newAddress.state.name,
                              value: newAddress.state.id,
                            }
                            : null
                        }
                        onChange={handleStateChange}
                        className="mb-2"
                        isDisabled={isLoading}
                      />
                    </div>
                    {/* City */}
                    <div>
                      <label className="block mb-1">City <span className="text-red-500">*</span></label>
                      <Select
                        options={cityOptions}
                        value={
                          newAddress.city.name
                            ? {
                              label: newAddress.city.name,
                              value: newAddress.city.name,
                            }
                            : null
                        }
                        onChange={handleCityChange}
                        className="mb-2"
                        isDisabled={isLoading}
                      />
                    </div>
                    {/* Postal Code */}
                    <div>
                      <label className="block mb-1">Postal Code <span className="text-red-500">*</span></label>
                      <input
                        id="postalCode"
                        type="text"
                        value={newAddress.postalCode}
                        onChange={handleNewAddressChange}
                        className="w-full p-1.5 border rounded"
                        required
                        disabled={isLoading}
                      />
                    </div>
                  </div>
                </form>
                <div className="flex gap-2 justify-between px-3 py-1">
                  {addresses.length > 0 && !showNewAddressForm && !showEditForm ? (
                    <>
                      <Button
                        text="Save and Proceed"
                        className="bg-[#66944b] hover:bg-[#FFFFFF] text-[#ffffff] hover:text-[#66944b] border-2 border-[#effbf5] hover:border-[#66944b] px-4 py-2 rounded-lg flex gap-2 items-center text-lg sm:text-xl lg:text-lg font-bold mx-auto"
                        onClick={handleConvertCartToSalesOrder}
                        disabled={isLoading || !selectedAddressId}
                      />

                    </>
                  ) : (
                    <div className="flex gap-2 justify-end w-full p-2">
                      <Button
                        text="Cancel"
                        className="bg-gray-50 border-1 border-gray-200  text-gray-500 hover:text-gray-600  hover:bg-gray-100 hover:border-gray-300 px-3 py-2 rounded-lg font-normal "
                        onClick={() => navigate(-1)}
                      />
                      <Button
                        text={showEditForm ? "Update" : "Save"}
                        className="font-normal"
                        onClick={handleSaveAndProceed}
                        disabled={isLoading}
                      />
                    </div>

                  )}
                </div>
              </div>
            )}

          </div>
        </>
      )}

      {step === 2 && (
        <OrderSummary
          createOrder={handleConvertCartToSalesOrder}
          selectedAddressId={selectedAddressId}
          selectedAddress={selectedAddress} // Pass the full address object
          shippingCost={shippingCost}
          setShippingCost={setShippingCost}
        />
      )}

      {/* {step === 3 && (
        <div className="text-center py-10">
          <div className="max-w-md mx-auto bg-white rounded-lg shadow-lg p-8">
            <div className="bg-green-100 border border-green-400 text-green-700 px-6 py-4 rounded-lg mb-6">
              <h2 className="text-2xl font-bold mb-3">
                Order Placed Successfully!
              </h2>
              <p className="mb-4">
                {bulkyOrderPlaced
                  ? "Both your bulky item order and regular order have been placed successfully!"
                  : "Your order has been created and is now visible in your account."}
              </p>
              <p className="text-sm font-mono bg-white p-2 rounded">
                Order ID: #{paymentOrderId || Date.now()}
              </p>
            </div>
            <div className="space-y-3">
              <button
                onClick={() => navigate("/account/orders")}
                className="w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                disabled={isLoading}
              >
                View My Orders
              </button>
              <button
                onClick={() => navigate("/shop")}
                className="w-full px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors font-medium"
                disabled={isLoading}
              >
                Continue Shopping
              </button>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default CheckoutPage;